<template>
  <section class="vac-intro">
    <h2 class="vac-intro-title">{{ $t('vacancies.title') }}</h2>
    <p class="vac-intro-text">{{ $t('vacancies.text') }}</p>
    <ul class="vac-intro-list">
      <li>{{ $t('vacancies.roles.personal') }}</li>
      <li>{{ $t('vacancies.roles.group') }}</li>
      <li>{{ $t('vacancies.roles.physio') }}</li>
    </ul>
  </section>
</template>

<script>
export default {
  name: 'VacanciesIntro',
};
</script>

<style scoped>
.vac-intro {
  padding-left: 16px;
  padding-right: 16px;
  margin-bottom: 8px;
}

@media screen and (min-width: 768px) {
  .vac-intro {
    padding-left: 24px;
    padding-right: 24px;
  }
}

@media screen and (min-width: 1024px) {
  .vac-intro {
    padding-left: 60px;
    padding-right: 60px;
  }
}

@media screen and (min-width: 1440px) {
  .vac-intro {
    padding-left: 80px;
    padding-right: 80px;
  }
}

@media screen and (min-width: 1920px) {
  .vac-intro {
    padding-left: 120px;
    padding-right: 120px;
  }
}

.vac-intro-title {
  margin: 32px 0 0;
  text-align: center;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 28px;
  line-height: 1.2;
  color: #000;
}

@media screen and (min-width: 768px) {
  .vac-intro-title {
    font-size: 36px;
  }
}

@media screen and (min-width: 1024px) {
  .vac-intro-title {
    margin-top: 60px;
    font-size: 40px;
  }
}

@media screen and (min-width: 1440px) {
  .vac-intro-title {
    font-size: 48px;
  }
}

@media screen and (min-width: 1920px) {
  .vac-intro-title {
    font-size: 54px;
  }
}

.vac-intro-text {
  margin: 16px 0 0;
  width: 100%;
  line-height: 1.2;
  font-size: 18px;
  font-weight: 400;
  color: #000;
}

@media screen and (min-width: 768px) {
  .vac-intro-text {
    margin-top: 24px;
  }
}

@media screen and (min-width: 1024px) {
  .vac-intro-text {
    font-size: 22px;
  }
}

@media screen and (min-width: 1440px) {
  .vac-intro-text {
    font-size: 24px;
  }
}

@media screen and (min-width: 1920px) {
  .vac-intro-text {
    font-size: 26px;
  }
}

.vac-intro-list {
  margin: 24px 0 0;
  padding-left: 22px;
  color: #000;
  line-height: 1.4;
  font-size: 18px;
}

@media screen and (min-width: 1024px) {
  .vac-intro-list {
    margin-top: 32px;
    font-size: 22px;
  }
}

@media screen and (min-width: 1440px) {
  .vac-intro-list {
    font-size: 24px;
  }
}

.vac-intro-list li + li {
  margin-top: 8px;
}
</style>
